import { CHARGE_TENANT } from '../constants/Actions';
import { makeRequestAction } from './actions';
import { ERROR_MESSAGES } from '../constants/Errors';

export default conversationId => (dispatch, getState, { apiV2 }) => {
  dispatch(makeRequestAction.start({ type: CHARGE_TENANT }));

  return apiV2
    .chargeTenant(conversationId)
    .then(() =>
      apiV2
        .getConversation(conversationId, {
          expand: ['messages,advertiser,tenant,stateHistory'],
        })
        .then(({ data }) => {
          dispatch(makeRequestAction.done(data));
        }),
    )
    .catch(({ cause }) => {
      if (cause) {
        switch (cause.status) {
          case 412:
            dispatch(makeRequestAction.error(ERROR_MESSAGES[412]));
            break;
          case 417:
            dispatch(makeRequestAction.error(ERROR_MESSAGES[417]));
            break;
          case 422:
            dispatch(makeRequestAction.error(ERROR_MESSAGES[422]));
            break;
          default:
            dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
        }

        return;
      }

      dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
    });
};
